import { render, staticRenderFns } from "./ListRewardCategory.vue?vue&type=template&id=06df6fa3&scoped=true"
import script from "./ListRewardCategory.vue?vue&type=script&lang=js"
export * from "./ListRewardCategory.vue?vue&type=script&lang=js"
import style0 from "./ListRewardCategory.vue?vue&type=style&index=0&id=06df6fa3&prod&scoped=true&lang=css"
import style1 from "./ListRewardCategory.vue?vue&type=style&index=1&id=06df6fa3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df6fa3",
  null
  
)

export default component.exports